import React from 'react'
import Information from '../public/Information/Information'
import MenuDoctor from './navDoctor/MenuDoctor'

function DataInformation() {
    return (
        <div>
            <MenuDoctor menuActive={'dataInformation'}/>
            <Information type='medical'/>
        </div>
    )
}

export default DataInformation